import { useMemo } from 'react';
import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery } from 'data-fetching-client';
export const GET_CONTACT_ENGAGEMENT_OPTIONS = 'campaignsPlatformContactEngagementOptions';
const QUERY_CONTACT_ENGAGEMENT_OPTIONS = registerQuery({
  fieldName: GET_CONTACT_ENGAGEMENT_OPTIONS,
  args: [],
  fetcher() {
    return http.get('associations/v1/definitions/0-35', {
      query: {
        includeFATypes: 'true'
      }
    }).then(res => {
      return (res || []).filter(definition => definition.category === 'USER_DEFINED' && definition.toObjectTypeId === '0-1');
    });
  }
});
export const useFetchContactEngagementOptions = () => {
  const {
    data,
    loading,
    error
  } = useQuery(QUERY_CONTACT_ENGAGEMENT_OPTIONS);
  const options = useMemo(() => {
    const associations = (data === null || data === void 0 ? void 0 : data[GET_CONTACT_ENGAGEMENT_OPTIONS]) || [];
    return associations.map(definition => ({
      text: definition.label || definition.name || `Association ${definition.id}`,
      value: definition.id
    }));
  }, [data]);
  return {
    options,
    loading,
    error
  };
};
export default useFetchContactEngagementOptions;